module.exports = __WEBPACK_EXTERNAL_MODULE__296__;